import { FullWidthImage } from "@alexanderathoodly/ui-library"
import React from "react"

export interface ImageSectionProps {
    template: "image-section"
    img: string
    height: number
    color: "light-blue" | "white"
}

const ImageSection: React.FC<ImageSectionProps> = ({ img, height }) => <FullWidthImage img={img} height={height} />

export { ImageSection }
